<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Arquivos</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Arquivos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0">Extensão</th>
                    <th scope="col" class="border-0">Data de criação</th>
                    <th scope="col" class="border-0">Externo</th>
                    <th scope="col" class="border-0">Interno</th>
                    <th scope="col" class="border-0">Parceiro</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(document, index) in documents" :key="index">
                    <td></td>
                    <td>{{ document.Code }}</td>
                    <td class="text-left">{{ document.Description }}</td>
                    <td>{{ document.Extension }}</td>
                    <td>{{ document.CreatedDate | date }}</td>
                    <td>
                      <i
                        :class="[
                          GetApplicationClass(document.IsExternalApplication),
                        ]"
                      ></i>
                    </td>
                    <td>
                      <i
                        :class="[
                          GetApplicationClass(document.IsInternalApplication),
                        ]"
                      ></i>
                    </td>
                    <td>
                      <i
                        :class="[
                          GetApplicationClass(document.IsPartnerApplication),
                        ]"
                      ></i>
                    </td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          aria-labelledby="dropdownMenuButton"
                          class="dropdown-menu"
                          id="dropTableOptions"
                        >
                          <a
                            v-if="$isAuthorize('Document', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetDocument(document.Id, true, false)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Document', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetDocument(document.Id, false, false)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Document', 'Get')"
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetDocument(document.Id, true, true)
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            v-if="$isAuthorize('Document', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteDocument($event, index)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      documents == null ||
                      documents == undefined ||
                      documents.length == 0
                    "
                  >
                    <td colspan="7">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormDocument"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="DocumentValidationForm">
          <div>
            <d-form-row>
              <!-- Code -->
              <d-col md="6" class="form-group">
                <label>Código</label>
                <d-form-input
                  type="text"
                  v-model="infoDocument.Code"
                  :disabled="true"
                />
              </d-col>
              <!-- Description -->
              <d-col md="6" class="form-group">
                <label>Descrição</label>
                <ValidationProvider
                  rules="required|min:1"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    type="text"
                    :class="validatedDocumentForm | showValidateError(invalid)"
                    v-model="infoDocument.Description"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedDocumentForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- Url -->
            <d-form-row v-if="isCreating">
              <d-col md="12" class="form-group">
                <label>Arquivo</label>
                <b-form-file
                  type="file"
                  placeholder="Selecione ou arraste um arquivo"
                  drop-placeholder="Solte o arquivo aqui"
                  browse-text="Selecionar"
                  @change="SelectDocumentFile($event, true)"
                  @input="SelectDocumentFile($event, false)"
                />
              </d-col>
            </d-form-row>
            <!-- CreatedDate -->
            <d-form-row v-if="isSeeing">
              <d-col md="6" class="form-group">
                <label>Extensão</label>
                <d-form-input
                  type="text"
                  v-bind:value="infoDocument.Extension"
                  readonly
                />
              </d-col>
              <d-col md="6" class="form-group">
                <label>Data do cadastro</label>
                <d-form-input
                  type="text"
                  v-bind:value="
                    infoDocument.CreatedDate | date('DD/MM/YYYY - HH:mm')
                  "
                  readonly
                />
              </d-col>
            </d-form-row>
            <d-form-row v-if="isSeeing">
              <d-col md="12" class="form-group">
                <label>URL</label>
                <d-form-input
                  type="text"
                  v-bind:value="infoDocument.Url"
                  readonly
                />
              </d-col>
            </d-form-row>
            <!-- IsExternalApplication -->
            <d-form-row>
              <d-col md="12">
                <d-checkbox
                  v-model="infoDocument.IsExternalApplication"
                  :disabled="isSeeing"
                  >Utilizado no Externo</d-checkbox
                >
              </d-col>
            </d-form-row>
            <!-- IsInternalApplication -->
            <d-form-row>
              <d-col md="12">
                <d-checkbox
                  v-model="infoDocument.IsInternalApplication"
                  :disabled="isSeeing"
                  >Utilizado no Interno</d-checkbox
                >
              </d-col>
            </d-form-row>
            <!-- IsPartnerApplication -->
            <d-form-row>
              <d-col md="12">
                <d-checkbox
                  v-model="infoDocument.IsPartnerApplication"
                  :disabled="isSeeing"
                  >Utilizado no Parceiro</d-checkbox
                >
              </d-col>
            </d-form-row>
          </div>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveDocument()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ isCreating == false ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Código"
            type="text"
            class="form-control"
            v-model="filter.Code"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Descrição"
            type="text"
            class="form-control"
            v-model="filter.Description"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.CodeApplication" :value="null">
            <option :value="null" selected>Aplicação</option>
            <option :value="1">Externo</option>
            <option :value="2">Interno</option>
            <option :value="3">Parceiro</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Document', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo arquivo"
      v-on:click="OpenMNewDocument()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "documents",
  data: function () {
    return {
      countFilter: 0,
      filter: {
        Code: null,
        Description: null,
        CodeApplication: null,
      },
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      loadingDownload: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      documents: [],
      infoDocument: {
        Code: null,
        Description: null,
        Url: null,
        Extension: null,
        IsExternalApplication: false,
        IsInternalApplication: false,
        IsPartnerApplication: false,
      },
      documentFile: null,
      isSeeing: false,
      isCreating: false,
      validatedDocumentForm: false,
      modalTitle: "Detalhes do arquivo",
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListDocument();
    },
    "pagination.RowsPerPage": function () {
      this.ListDocument();
    },
  },
  mounted() {
    this.ListDocument();
  },
  methods: {
    SelectDocumentFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      FileToBase64(file)
        .then((response) => {
          this.documentFile = file;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    GetFormData(object) {
      let formData = new FormData();
      Object.keys(object).forEach((key) => formData.append(key, object[key]));
      return formData;
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListDocument();
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        Description: null,
        CodeApplication: null,
      };
      this.ListDocument();
    },
    GetApplicationClass: function (isApplication) {
      return isApplication ? "fas fa-check fa-green" : "fas fa-minus";
    },
    ListDocument: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Description)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Code": this.filter.Code,
          "Object.Description": this.filter.Description,
          CodeApplication: this.filter.CodeApplication,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListDocument", { params: data })
        .then(
          (response) => {
            this.documents = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar os arquivos",
              "danger",
              "Arquivos",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetDocument: function (id, seeing, download) {
      if (download) this.loadingDownload = true;
      else {
        this.loadingModal = true;
        this.isCreating = false;
        this.ResetInfoDocument();
        this.OpenMDocument();
      }

      this.$store
        .dispatch("GetDocument", { id: id })
        .then((response) => {
          this.infoDocument = response;

          if (seeing) {
            this.isSeeing = true;
            this.modalTitle = "Detalhes do arquivo";
          } else {
            this.isSeeing = false;
            this.modalTitle = "Editar arquivo";
          }

          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Arquivos"
            );
            window.open(response.Url, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do arquivo",
            "danger",
            "Arquivos",
            error
          );
        })
        .finally(() => {
          if (download) {
            $("#dropTableOptions").dropdown("hide");
            setTimeout(() => {
              this.loadingDownload = false;
            }, 1200);
          } else this.loadingModal = false;
        });
    },
    OpenMDocument: function () {
      this.validatedDocumentForm = false;
      this.$bvModal.show("mFormDocument");
    },
    OpenMNewDocument: function () {
      this.ResetInfoDocument();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo arquivo";
      this.OpenMDocument();
    },
    SaveDocument: function () {
      this.validatedDocumentForm = true;
      if (
        !this.infoDocument.IsExternalApplication &&
        !this.infoDocument.IsInternalApplication &&
        !this.infoDocument.IsPartnerApplication
      ) {
        this.$makeToast(
          "Informe pelo menos uma aplicação para utilização deste arquivo",
          "danger",
          "Arquivo"
        );
        return;
      }
      this.$refs.DocumentValidationForm.validate().then((isValid) => {
        if (isValid) {
          if (this.isCreating) {
            // Add
            if (this.documentFile == null || this.documentFile == undefined) {
              this.$makeToast("Selecione um arquivo", "danger", "Arquivo");
              return;
            }
            this.loadingAddUpdate = true;
            let document = JSON.parse(JSON.stringify(this.infoDocument));
            delete document.Url;
            var formData = this.GetFormData(document);
            formData.append("File", this.documentFile, this.documentFile.name);
            this.$store
              .dispatch("AddDocument", formData)
              .then(() => {
                this.$makeToast(
                  "O arquivo foi cadastrado corretamente na base de dados",
                  "success",
                  "Arquivo"
                );
                this.ListDocument();
                this.$bvModal.hide("mFormDocument");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar o arquivo",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.loadingAddUpdate = true;
            this.$store
              .dispatch("UpdateDocument", this.infoDocument)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Arquivo"
                );
                this.ListDocument();
                this.$bvModal.hide("mFormDocument");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o arquivo",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    ResetInfoDocument: function () {
      this.infoDocument = {
        Code: null,
        Description: null,
        Url: null,
        Extension: null,
        IsExternalApplication: false,
        IsInternalApplication: false,
        IsPartnerApplication: false,
      };
    },
    ConfirmDeleteDocument: function (e, i) {
      e.preventDefault();
      let deleted = this.documents[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${deleted.Description}?`,
        "Confirmar",
        this.DeleteDocument,
        i
      );
    },
    DeleteDocument: function (i) {
      let deleted = this.documents[i];
      this.$store
        .dispatch("DeleteDocument", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Description} foi removido da sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListDocument();
          this.$bvModal.hide("mFormDocument");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o arquivo",
            error
          );
        });
    },
  },
};
</script>

<style>
.fa-green {
  color: #0ac37f;
}
.custom-file-input:focus ~ .custom-file-label::after {
  color: black;
  background: #e5e7ec;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/documents.vue